export const ToggleThemeButton = ({ isOn, handleToggle }) => {
  return (
    <div
      onClick={handleToggle}
      className={`relative w-24 h-8 flex items-center rounded-full transition-all duration-300 ease-in-out  cursor-pointer

                        ${isOn ? "bg-blue-600" : "bg-gray-400"} 

                        focus:outline-none focus:ring-2 focus:ring-blue-300`}
    >
      <span
        className={`absolute left-1 top-1 w-6 h-6 rounded-full shadow transition-transform duration-300 ease-in-out 

                            ${
                              isOn
                                ? "translate-x-16 bg-white shadow-lg"
                                : "bg-white"
                            }`}
      />

      <span
        className={`absolute transition-opacity duration-200 text-white text-sm left-2 ${
          isOn ? "opacity-100" : "opacity-0"
        }`}
      >
        Dark
      </span>

      <span
        className={`absolute transition-opacity duration-200 text-white text-sm right-2 ${
          isOn ? "opacity-0" : "opacity-100"
        }`}
      >
        Light
      </span>
    </div>
  );
};

export default ToggleThemeButton;
